import { render, staticRenderFns } from "./pageFive.vue?vue&type=template&id=48a6838c"
import script from "./pageFive.vue?vue&type=script&lang=js"
export * from "./pageFive.vue?vue&type=script&lang=js"
import style0 from "../../../statistics/css/addProject.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports